import { IGa4ViewItem } from "../interfaces/ga4-event.interface";
import { ga4EventService } from "../services/ga4-event.service";
import { Ga4EcommerceComponent } from "./Ga4Ecommerce.component";
import { Ga4ViewItemEventParams } from "../constants/event-params.constants";
import { LocalStorage } from "@contorion/core";

export class Ga4ViewItemEvent extends Ga4EcommerceComponent {
    protected localStorage: LocalStorage;

    protected get isFromBundleBannerSku(): string {
        if (this.localStorage) {
            return this.localStorage.getValue(Ga4ViewItemEventParams.clickOnBundleBanner);
        }
    }

    protected get isFromBundlePageSku(): string {
        if (this.localStorage) {
            return this.localStorage.getValue(Ga4ViewItemEventParams.clickOnBundleItem);
        }
    }
    constructor(protected element: HTMLElement) {
        super(element, 'Ga4ViewItemEvent');
    }

    protected fire() {
        // if its single/simple or config product
        const tcVars = window.tc_vars;
        this.localStorage = new LocalStorage();
        if (!Array.isArray(tcVars.product_unitprice_ati) || tcVars.page_cat2 === 'config') {
            const value = Array.isArray(tcVars.product_unitprice_ati) ? tcVars.product_unitprice_ati[0] : tcVars.product_unitprice_ati;

            const viewItemEventData: IGa4ViewItem = {
                ecommerce: {
                    currency: window.tc_vars.product_currency,
                    value: parseFloat(value),
                    items: ga4EventService.getProductItems(),
                },
                is_from_bundle_banner_sku: this.isFromBundleBannerSku || undefined,
                is_from_bundle_page_sku: this.isFromBundlePageSku || undefined,
            };

            ga4EventService.viewItem(viewItemEventData);

            if (this.localStorage) {
                this.localStorage.removeValue(Ga4ViewItemEventParams.clickOnBundleBanner);
                this.localStorage.removeValue(Ga4ViewItemEventParams.clickOnBundleItem);
            }
        }
    }
}
